import e from "./index.ce.vue.js";
import { defineAndRegisterElement as i } from "../../utils/register-element.js";
const o = i(e);
export {
  o as initDeliveryDetails
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-details/index.js
// module id = 1231
// module chunks = 41